var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMarketplace(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 22,
    viewBox: "0 0 23 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.8333 21V15C14.8333 14.3777 14.8333 14.0666 14.7122 13.8289C14.6057 13.6198 14.4358 13.4499 14.2267 13.3433C13.989 13.2222 13.6779 13.2222 13.0556 13.2222H9.94445C9.32211 13.2222 9.01102 13.2222 8.77334 13.3433C8.56428 13.4499 8.3943 13.6198 8.28777 13.8289C8.16667 14.0666 8.16667 14.3777 8.16667 15V21M1.5 5.44444C1.5 7.28539 2.99239 8.77778 4.83333 8.77778C6.67428 8.77778 8.16667 7.28539 8.16667 5.44444C8.16667 7.28539 9.659 8.77778 11.5 8.77778C13.341 8.77778 14.8333 7.28539 14.8333 5.44444C14.8333 7.28539 16.3257 8.77778 18.1667 8.77778C20.0077 8.77778 21.5 7.28539 21.5 5.44444M5.05556 21H17.9444C19.189 21 19.8113 21 20.2867 20.7578C20.7048 20.5448 21.0448 20.2048 21.2578 19.7867C21.5 19.3113 21.5 18.689 21.5 17.4444V4.55556C21.5 3.311 21.5 2.68871 21.2578 2.21336C21.0448 1.79521 20.7048 1.45526 20.2867 1.24221C19.8113 1 19.189 1 17.9444 1H5.05556C3.811 1 3.18871 1 2.71336 1.24221C2.29521 1.45526 1.95526 1.79521 1.74221 2.21336C1.5 2.68871 1.5 3.31099 1.5 4.55556V17.4444C1.5 18.689 1.5 19.3113 1.74221 19.7867C1.95526 20.2048 2.29521 20.5448 2.71336 20.7578C3.18871 21 3.81099 21 5.05556 21Z",
    stroke: "#5E5E5E",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMarketplace);
export default __webpack_public_path__ + "static/media/marketplace.387849e844bdf4e89255d0a3a865055f.svg";
export { ForwardRef as ReactComponent };